module.exports = __webpack_public_path__ + "img/portfolio-05-480x343.c13f4b4c.jpg";